<template>
  <v-dialog v-model="propDialog" width="400px" persistent>
    <v-card style="padding: 15px">
      <v-icon
        class="ma-1 right top"
        style="position: absolute"
        color="#0D47A1"
        large
        @click="$emit('closeDialog')"
        >mdi-close-circle</v-icon
      >
      <div class="container">
        <v-img width="150" :src="$appInfo.icon"> </v-img>
        <v-btn
          block
          color="#11476b"
          style="color: white"
          class="mt-2"
          @click="goto('Inicio')"
          ><h2>INICIO</h2></v-btn
        >
        <v-btn
          block
          color="#11476b"
          style="color: white"
          class="mt-2"
          @click="goto('Nosotros')"
          ><h2>QUIENES SOMOS</h2></v-btn
        >
        <v-btn
          block
          color="#11476b"
          style="color: white"
          class="mt-2"
          @click="goto('Cursos')"
          ><h2>CURSOS</h2></v-btn
        >
        <v-btn
          block
          color="#11476b"
          style="color: white"
          class="mt-2"
          @click="goto('Elibro')"
          ><h2>E-Libro</h2></v-btn
        >
        <v-btn
          block
          color="#11476b"
          style="color: white"
          class="mt-2"
          @click="goto('Noticias')"
          ><h2>NOTICIAS</h2></v-btn
        >
        <v-btn
          block
          color="#11476b"
          style="color: white"
          class="mt-2"
          @click="goto('Aula')"
          ><h2>AULA VIRTUAL</h2></v-btn
        >
        <v-btn
          block
          color="#11476b"
          style="color: white"
          class="mt-2"
          @click="goto('Contactos')"
          ><h2>CONTACTANOS</h2></v-btn
        >
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import QRCode from "qrcode";
export default {
  props: {
    propDialog: { type: Boolean },
    propGenNewQr: { type: String },
  },
  data() {
    return {
      remote: false,
      remoteCode: "",
      idPcOwner: "",
      sms: "",
    };
  },
  mounted() {},
  created() {},
  watch: {
    propGenNewQr() {
      this.genQr();
    },
  },
  methods: {
    goto(aux) {
      this.$emit("closeDialog");
      if (aux == "Aula") {
        window.location.href = "https://aulavirtual.inseg.com.ec/";
        return;
      }
      if (aux == "Elibro") {
        window.open("https://elibro.net/es/lc/insegt/", "_blank");
        return;
      }
      this.$router.push({ name: aux });
    },
    async genQr() {
      try {
        this.idPcOwner = this.$route.params.idpcowner.toString();
      } catch (error) {
        this.idPcOwner = "";
      }
      try {
        if (this.idPcOwner.length < 2) {
          this.idPcOwner = localStorage.getItem("miIdPc");
        }
        var qrPath = window.location.href;
        let qrCanvas = await QRCode.toCanvas(qrPath, {
          color: {
            dark: "#0000FF", // Azul (color de los cuadrados del QR)
            light: "#FFFFFF", // Blanco (fondo)
          },
        });
        // Limpiar contenido anterior
        this.$refs.qrcode.innerHTML = "";
        this.$refs.qrcode.appendChild(qrCanvas);
      } catch (err) {
        console.error("Error generando QR:", err);
      }
    },
    gotox(remote) {
      if (!remote) {
        this.$router.push({
          name: "Notes",
          params: { idpc: localStorage.getItem("miIdPc") },
        });
      } else {
        localStorage.setItem("remoteCode", remote);
        this.$router.push({ name: "Notes", params: { idpc: remote } });
      }
    },
  },
};
</script>
<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.qr-wrapper {
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}
</style>
